import * as Styled from './styled'
import { SQUARE_ASPECT_RATIO } from 'utils/aspectRatio'

interface IImageContainerProps {
  filePath?: string | null
  isImageLoading: boolean
  onImageLoad: () => void
  aspectRatio?: string
}

const ImageContainer = ({
  filePath,
  isImageLoading,
  onImageLoad,
  aspectRatio = SQUARE_ASPECT_RATIO
}: IImageContainerProps) => {
  return (
    <Styled.ImageWrapper $aspectRatio={aspectRatio}>
      {isImageLoading && (
        <Styled.AiImageSkeletonItem $aspectRatio={aspectRatio} />
      )}
      <Styled.GeneratedImage
        src={filePath || undefined}
        $aspectRatio={aspectRatio}
        alt="ai-generated-image"
        onLoad={onImageLoad}
        $isImageLoading={isImageLoading}
        loading="lazy"
      />
    </Styled.ImageWrapper>
  )
}

export default ImageContainer
